// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2A_9b","savePackageButton":"ClientWallet_savePackageButton__34hXy"};